import * as Sentry from "@sentry/react";

// A fetch hook outside our bundle (a browser extension) reads every response a second time without handling
// failures. When Firestore's listen channel drops or aborts a request, that read rejects with one of these two,
// with no stack frame. Firestore reconnects on its own (PF-6304). Our own failed fetches keep their frames and
// carry the host in the message, so they still arrive.
const FOREIGN_STREAM_READ_ERRORS = new Set(["Failed to fetch", "AbortError: The user aborted a request."]);

const isForeignStreamReadError = (event: Sentry.ErrorEvent) => {
  const exception = event.exception?.values?.[0];
  return (
    exception?.mechanism?.type === "auto.browser.global_handlers.onunhandledrejection" &&
    !exception.stacktrace?.frames?.length &&
    FOREIGN_STREAM_READ_ERRORS.has(exception.value ?? "")
  );
};

export const useSentry = () => {
  Sentry.init({
    dsn: "https://e8ba78f442b61fe646b75e544ccb0d2a@o1299768.ingest.us.sentry.io/4512009839181824",
    environment: import.meta.env.VITE_ENV,
    // Ties an error to the deploy it came from; the same value the VersionTag shows.
    release: import.meta.env.VITE_VERSION,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/patient\.physiofit\.app/,
      /^https:\/\/patient-physiofit\.web\.app/,
      /^https:\/\/patient-physiofit-dev\.web\.app/,
    ],
    beforeSend: (event) => (isForeignStreamReadError(event) ? null : event),
    // No Session Replay: every screen here carries patient master data,
    // insurance numbers and a signature field. Turn it on only deliberately.
  });
};
